import { render, staticRenderFns } from "./RouteForm.vue?vue&type=template&id=315346de&scoped=true&"
import script from "./RouteForm.vue?vue&type=script&lang=js&"
export * from "./RouteForm.vue?vue&type=script&lang=js&"
import style0 from "./RouteForm.vue?vue&type=style&index=0&id=315346de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315346de",
  null
  
)

export default component.exports